/* eslint-disable @typescript-eslint/no-explicit-any */
import piechartIcon from '../../../assets/piechartIcon.svg';
import pauseIcon from '../../../assets/pauseIcon.svg';
import React, { useState } from 'react';
import Timer from '@/components/ui/timer';
import { mixPanelServiceInstance } from '@/analytics/mixpanel';
import { mixPanelEvents } from '@/analytics/mixpanel/events';
type TDocumentHeader = {
  onPauseHandler: () => void;
  source: string;
  taskDetails: any;
  isClassifiedFail?: boolean;
};

const DocumentHeader: React.FC<TDocumentHeader> = ({
  onPauseHandler = () => {},
  source,
  taskDetails,
  isClassifiedFail
}) => {
  const [isPaused, setIsPaused] = useState(false);

  const handlePause = () => {
    setIsPaused(true);
    setTimeout(() => {
    onPauseHandler();
    }, 100);
    if (source === 'validator') {
      mixPanelServiceInstance.track(mixPanelEvents.RECORD_MANAGEMENT.DOCUMENT_VALIDATION_PAUSED, {
        document_id: taskDetails?.focus?.reference?.split('/')?.[1],
        validator_id: taskDetails?.owner?.reference?.split('/')?.[1],
      });
    }
    if (source === 'reviewer' && isClassifiedFail) {
      mixPanelServiceInstance.track(mixPanelEvents.RECORD_MANAGEMENT.DOCUMENT_TYPE_REVIEW_PAUSED, {
        document_id: taskDetails?.focus?.reference?.split('/')?.[1],
        reviewer_id: taskDetails?.owner?.reference?.split('/')?.[1],
      });
    }
    // if (source === 'supervisor') {
    //   mixPanelServiceInstance.track(mixPanelEvents.RECORD_MANAGEMENT.ESCALATED_DOCUMENT_REVIEW_PAUSED, {
    //     document_id: taskDetails?.focus?.reference?.split('/')?.[1],
    //     supervisor_id: taskDetails?.owner?.reference?.split('/')?.[1],
    //   });
    // }

  const getTotalDocumentsToday = () => {
    const storedData = JSON.parse(localStorage.getItem("documentCount") || "{}");
    const today = new Date().toISOString().split("T")[0];

    return storedData.date === today ? storedData.count : 0;
  };

  return (
    <div className="flex px-10 py-3 border-b justify-between">
      <div className="flex flex-wrap content-center">
        <img src={piechartIcon} className="mr-2" />
        <p className="text-charcoal-60 text-lg ">{`${getTotalDocumentsToday() || 0} documents completed`}</p>
      </div>
      <div className="flex content-center">
        <p className="text-charcoal-50 text-lg flex">
          Time spent on this document:
          <span className="text-charcoal-100 text-lg ps-2">
            <Timer isPaused={isPaused} />
          </span>
        </p>
        <button
          className="flex ml-6 items-center flex justify-center border-papaya-40 border rounded-full p-1 text-sm"
          onClick={handlePause}
        >
          <div className="bg-papaya-80 rounded-full h-5 w-5 items-center flex justify-center mr-2">
            <img src={pauseIcon} />
          </div>
          Pause session
        </button>
      </div>
    </div>
  );
};

  const getTotalDocumentsToday = () => {
    const storedData = JSON.parse(localStorage.getItem("documentCount") || "{}");
    const today = new Date().toISOString().split("T")[0];

    return storedData.date === today ? storedData.count : 0;
  };

  return (
    <div className="flex px-10 py-3 border-b justify-between">
      <div className="flex flex-wrap content-center">
        <img src={piechartIcon} className="mr-2" />
        <p className="text-charcoal-60 text-lg ">{`${getTotalDocumentsToday() || 0} documents completed`}</p>
      </div>
      <div className="flex content-center">
        <p className="text-charcoal-50 text-lg flex">
          Time spent on this document:
          <span className="text-charcoal-100 text-lg ps-2">
            <Timer isPaused={isPaused} />
          </span>
        </p>
        <button
          className="flex ml-6 items-center flex justify-center border-papaya-40 border rounded-full p-1 text-sm"
          onClick={handlePause}
        >
          <div className="bg-papaya-80 rounded-full h-5 w-5 items-center flex justify-center mr-2">
            <img src={pauseIcon} />
          </div>
          Pause session
        </button>
      </div>
    </div>
  );
};
export default DocumentHeader;
